export default __webpack_public_path__ + "static/media/480_dummy2016-architekturbuero01-de.ada90d23.png";